import React from 'react';
import Button from '../button/Button';
import { useInView } from 'react-intersection-observer';
import { useState ,useEffect} from 'react';

const HeroContent = ({t,data,handlerSelectModal}) =>{

  const{ ref,inView } = useInView({
    threshold:0.5,
  })



  return (
    <>
      <div ref ={ref} className="hero-description">
        <div className="hero-description-block"></div>
        <div className={`hero-capture animation ${inView  ? 'show-image': ""}`}>
          {data.capture}
        </div>
        <div className={`hero-text animation ${inView ? 'show-text': ""}`}>
          {data.text}
        </div>
        <div className={`hero-button-wrapper animation ${inView  ? 'show-button': ""}`}>
          <Button text = {t("button_start_your_journey")}  handlerSelectModal={handlerSelectModal}/>
        </div>
        </div>
        <div className={`hero-image animation ${inView ? 'show-image': ""}`}>
          <img src={data.img} alt={`${data.altImage}`}/>
        </div>
    </>
  );
}

export default HeroContent;